"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.token = token;
exports.setToken = setToken;
var lodash_isnil_1 = __importDefault(require("lodash.isnil"));
var constants_1 = require("../constants");
var TOKEN_PREFIX = (_a = constants_1.PREFIX === null || constants_1.PREFIX === void 0 ? void 0 : constants_1.PREFIX.toLowerCase().concat('-')) !== null && _a !== void 0 ? _a : '';
function isTokenValid(token) {
    return !(0, lodash_isnil_1.default)(token) && token !== '';
}
function token(token) {
    if (!isTokenValid(token)) {
        throw new Error("Invalid token: '".concat(token, "'"));
    }
    return "var(--".concat(TOKEN_PREFIX).concat(token, ")");
}
function setToken(token, value) {
    if (!isTokenValid(token)) {
        throw new Error("Invalid token: '".concat(token, "'"));
    }
    return "--".concat(TOKEN_PREFIX).concat(token, ": ").concat(value);
}
